import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, distinctUntilChanged, filter, map } from 'rxjs';
import { ProductListService } from '../../../../SGRE-custom/product-list-page/services/product-list.service';

@Component({
  selector: 'app-no-products-found',
  templateUrl: './no-products-found.component.html',
  styleUrl: './no-products-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NoProductsFoundComponent implements OnInit {

  @Input() data: Observable<CmsParagraphComponent>;
  isEmpty$: Observable<boolean>;

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    private productsService: ProductListService
  ) { }

  ngOnInit(): void {
    this.isEmpty$ = this.productsService.getSearchResults()
      .pipe(
        // Skip null/undefined values which indicate loading state
        filter(data => data !== undefined && data !== null),
        map(data => {
          // Then check if the products array exists and is empty
          if (Array.isArray(data.products)) {
            return data.products.length === 0;
          }
          return false;
        }),
        distinctUntilChanged()
      );
  }
}
